import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Axios from '../../authorization/axiosInstance';

interface CartList {
    id: string,
    productDetails: {
      id: string,
      productName: string,
      isAvailable: boolean,
      branch: {
        id: string,
        branchName: string,
        image: [
          {
            filePath: string,
          }
        ],
        categoryTypes: [
          {
            id: string,
            name: string
          },
        ],
        startTime: string,
        endTime: string,
        branchStatus: string,
      },
      price: string,
      description: string,
      images: [
        {
          filePath: string
        }
      ],
      status: string,
    },
    variantDetails: {
      variant: {
        id: string,
        variantName: string,
      },
      price: string
    },
    cartCount: number,
  }

interface billDetails {
  totAmt: string,
  dlvCharges: string,
  isCoupenApplied: boolean,
  coupenAmount: string,
  subTotalAmt: string,
  isOfferApplied: boolean,
  offerAmount: string
}

interface CartListState {
  data: CartList[];
  loading: boolean;
  message: string;
  error: boolean;
  code: any ;
  count: number;
  billDetails: billDetails | null;
}

const initialState: CartListState = {
  data: [],
  loading: false,
  message: '',
  error: false,
  code: '',
  count: 0,
  billDetails: null
};

export const fetchCarts = createAsyncThunk<any, any>('CartList/fetchData', async (params, thunkAPI) => {
  return await Axios.get(`/cart`, { params: params }).catch(thunkAPI.rejectWithValue)
});

export const cartSlice = createSlice({
  name: 'carts',
  initialState,
  reducers: {
    clearState: (state) => {
      state.data = [];
      state.loading = false;
      state.message = '';
      state.error = false;
      state.code = '';
      state.count = 0;
      state.billDetails = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCarts.pending, state => {
        state.loading = true;
        state.message = '';
        state.error = false;
      })
      .addCase(fetchCarts.fulfilled, (state, action: any) => {
        state.loading = false;
        state.code = action?.payload?.data?.code;
        state.data = action.payload?.data.data;
        state.message = action?.payload?.data?.message;
        state.error = false;
        state.count = action?.payload?.data?.count;
        state.billDetails = action?.payload?.data?.billDetails;
      })
      .addCase(fetchCarts.rejected, (state, action: any) => {
        state.loading = false;
        state.code = action?.payload?.response?.data?.code;
        state.message = action?.payload?.response?.data?.message || 'Need to login first';
        state.error = true;
      })
  },
});

export const { clearState } = cartSlice.actions;
export default cartSlice.reducer;
